function ShowDeletedFilter() {
    return function(entityArray, showDeleted) {
        return entityArray.filter(entity => showDeleted || !entity.deleted);
    };
}

angular.module('egAngularUtils').filter('egShowDeleted', ShowDeletedFilter);